/**
 * @fileoverview gRPC-Web generated client stub for customers_group_endpoint
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.1
// 	protoc              v6.32.1
// source: group.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as group_pb from './group_pb'; // proto import: "group.proto"


export class GroupEndpointClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorAdd = new grpcWeb.MethodDescriptor(
    '/customers_group_endpoint.GroupEndpoint/Add',
    grpcWeb.MethodType.UNARY,
    group_pb.AddGroupRequest,
    group_pb.AddGroupResponse,
    (request: group_pb.AddGroupRequest) => {
      return request.serializeBinary();
    },
    group_pb.AddGroupResponse.deserializeBinary
  );

  add(
    request: group_pb.AddGroupRequest,
    metadata?: grpcWeb.Metadata | null): Promise<group_pb.AddGroupResponse>;

  add(
    request: group_pb.AddGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: group_pb.AddGroupResponse) => void): grpcWeb.ClientReadableStream<group_pb.AddGroupResponse>;

  add(
    request: group_pb.AddGroupRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: group_pb.AddGroupResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_group_endpoint.GroupEndpoint/Add',
        request,
        metadata || {},
        this.methodDescriptorAdd,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_group_endpoint.GroupEndpoint/Add',
    request,
    metadata || {},
    this.methodDescriptorAdd);
  }

  methodDescriptorUpdate = new grpcWeb.MethodDescriptor(
    '/customers_group_endpoint.GroupEndpoint/Update',
    grpcWeb.MethodType.UNARY,
    group_pb.UpdateGroupRequest,
    group_pb.UpdateGroupResponse,
    (request: group_pb.UpdateGroupRequest) => {
      return request.serializeBinary();
    },
    group_pb.UpdateGroupResponse.deserializeBinary
  );

  update(
    request: group_pb.UpdateGroupRequest,
    metadata?: grpcWeb.Metadata | null): Promise<group_pb.UpdateGroupResponse>;

  update(
    request: group_pb.UpdateGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: group_pb.UpdateGroupResponse) => void): grpcWeb.ClientReadableStream<group_pb.UpdateGroupResponse>;

  update(
    request: group_pb.UpdateGroupRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: group_pb.UpdateGroupResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_group_endpoint.GroupEndpoint/Update',
        request,
        metadata || {},
        this.methodDescriptorUpdate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_group_endpoint.GroupEndpoint/Update',
    request,
    metadata || {},
    this.methodDescriptorUpdate);
  }

  methodDescriptorDelete = new grpcWeb.MethodDescriptor(
    '/customers_group_endpoint.GroupEndpoint/Delete',
    grpcWeb.MethodType.UNARY,
    group_pb.DeleteGroupRequest,
    group_pb.DeleteGroupResponse,
    (request: group_pb.DeleteGroupRequest) => {
      return request.serializeBinary();
    },
    group_pb.DeleteGroupResponse.deserializeBinary
  );

  delete(
    request: group_pb.DeleteGroupRequest,
    metadata?: grpcWeb.Metadata | null): Promise<group_pb.DeleteGroupResponse>;

  delete(
    request: group_pb.DeleteGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: group_pb.DeleteGroupResponse) => void): grpcWeb.ClientReadableStream<group_pb.DeleteGroupResponse>;

  delete(
    request: group_pb.DeleteGroupRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: group_pb.DeleteGroupResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_group_endpoint.GroupEndpoint/Delete',
        request,
        metadata || {},
        this.methodDescriptorDelete,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_group_endpoint.GroupEndpoint/Delete',
    request,
    metadata || {},
    this.methodDescriptorDelete);
  }

  methodDescriptorGetGroups = new grpcWeb.MethodDescriptor(
    '/customers_group_endpoint.GroupEndpoint/GetGroups',
    grpcWeb.MethodType.UNARY,
    group_pb.GetGroupsRequest,
    group_pb.GetGroupsResponse,
    (request: group_pb.GetGroupsRequest) => {
      return request.serializeBinary();
    },
    group_pb.GetGroupsResponse.deserializeBinary
  );

  getGroups(
    request: group_pb.GetGroupsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<group_pb.GetGroupsResponse>;

  getGroups(
    request: group_pb.GetGroupsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: group_pb.GetGroupsResponse) => void): grpcWeb.ClientReadableStream<group_pb.GetGroupsResponse>;

  getGroups(
    request: group_pb.GetGroupsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: group_pb.GetGroupsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_group_endpoint.GroupEndpoint/GetGroups',
        request,
        metadata || {},
        this.methodDescriptorGetGroups,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_group_endpoint.GroupEndpoint/GetGroups',
    request,
    metadata || {},
    this.methodDescriptorGetGroups);
  }

  methodDescriptorGetUnRestrictedGroups = new grpcWeb.MethodDescriptor(
    '/customers_group_endpoint.GroupEndpoint/GetUnRestrictedGroups',
    grpcWeb.MethodType.UNARY,
    group_pb.GetUnRestrictedGroupsRequest,
    group_pb.GetUnRestrictedGroupsResponse,
    (request: group_pb.GetUnRestrictedGroupsRequest) => {
      return request.serializeBinary();
    },
    group_pb.GetUnRestrictedGroupsResponse.deserializeBinary
  );

  getUnRestrictedGroups(
    request: group_pb.GetUnRestrictedGroupsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<group_pb.GetUnRestrictedGroupsResponse>;

  getUnRestrictedGroups(
    request: group_pb.GetUnRestrictedGroupsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: group_pb.GetUnRestrictedGroupsResponse) => void): grpcWeb.ClientReadableStream<group_pb.GetUnRestrictedGroupsResponse>;

  getUnRestrictedGroups(
    request: group_pb.GetUnRestrictedGroupsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: group_pb.GetUnRestrictedGroupsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_group_endpoint.GroupEndpoint/GetUnRestrictedGroups',
        request,
        metadata || {},
        this.methodDescriptorGetUnRestrictedGroups,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_group_endpoint.GroupEndpoint/GetUnRestrictedGroups',
    request,
    metadata || {},
    this.methodDescriptorGetUnRestrictedGroups);
  }

  methodDescriptorGetAvailableProfies = new grpcWeb.MethodDescriptor(
    '/customers_group_endpoint.GroupEndpoint/GetAvailableProfies',
    grpcWeb.MethodType.UNARY,
    group_pb.GetAvailableProfilesRequest,
    group_pb.GetAvailableProfilesResponse,
    (request: group_pb.GetAvailableProfilesRequest) => {
      return request.serializeBinary();
    },
    group_pb.GetAvailableProfilesResponse.deserializeBinary
  );

  getAvailableProfies(
    request: group_pb.GetAvailableProfilesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<group_pb.GetAvailableProfilesResponse>;

  getAvailableProfies(
    request: group_pb.GetAvailableProfilesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: group_pb.GetAvailableProfilesResponse) => void): grpcWeb.ClientReadableStream<group_pb.GetAvailableProfilesResponse>;

  getAvailableProfies(
    request: group_pb.GetAvailableProfilesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: group_pb.GetAvailableProfilesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/customers_group_endpoint.GroupEndpoint/GetAvailableProfies',
        request,
        metadata || {},
        this.methodDescriptorGetAvailableProfies,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/customers_group_endpoint.GroupEndpoint/GetAvailableProfies',
    request,
    metadata || {},
    this.methodDescriptorGetAvailableProfies);
  }

}

